export default __webpack_public_path__ + "static/media/CouchPotato.8abd7951.png";